module.exports = __webpack_public_path__ + "static/far-cry_smartphone-780fe3a01f20c8bd287f5990e2d3c240.avif";